import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Forms, Loading, Paging, SystemText } from '@salesperformanceint/e4shared';
import { apiGet } from 'services';
import { Card } from '../shared';
import BlobImage from 'components/blobImage';

export const Richardson = ({ allowMultiple, pageSize, onAddItem, noResultsMessage, testId }) => {
    const [content, setContent] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [recordCount, setRecordCount] = useState(0);
    const [competency, setCompetency] = useState(null);
    const [loading, setLoading] = useState(true);

    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));
    const competencies = useSelector(state => state.user.downlineCompetencies);
    const competenciesMapped = competencies ? competencies.map(c => ({ id: c.id, name: `${c.area} - ${c.name}` })) : [];

    const getContent = useCallback(() => {
        apiGet(
            `richardson/content?page=${page || 1}&sort=1&sortdirection=asc&pagesize=${pageSize}&search=${
                search || ''
            }&competency=${competency || 0}`,
            guid,
            response => {
                setContent(response?.content);
                setRecordCount(response?.records);
                setLoading(false);
            }
        );
    }, [guid, competency, page, search]);

    useEffect(() => {
        setPage(1);
    }, [search, competency]);

    useEffect(() => {
        getContent();
    }, [guid, page, search, competency, getContent]);

    if (loading) return <Loading />;

    return (
        <div data-testid={testId}>
            <div>
                <Forms.Text
                    label={SystemText('Admin/Forms/FilePicker/Content/Richardson/Filters/Title')}
                    id="search"
                    placeholder={SystemText('Admin/Forms/FilePicker/Content/Richardson/Fields/Search/Placeholder')}
                    value={search}
                    onChange={setSearch}
                    icon="fa-search"
                />
            </div>
            {Boolean(competenciesMapped?.length) && (
                <div className="no-label">
                    <Forms.Select
                        id="competency_Id"
                        placeholder={SystemText('Admin/Forms/FilePicker/Content/Richardson/Fields/Competencies/Placeholder')}
                        data={competenciesMapped}
                        value={competency}
                        onChange={setCompetency}
                    />
                </div>
            )}
            {!content?.length ? (
                <div>{noResultsMessage}</div>
            ) : (
                <>
                    <label>{SystemText('Admin/Forms/FilePicker/Content/Richardson/Title')}</label>
                    <div className="text-sm mb5">{SystemText('Admin/Forms/FilePicker/Content/Richardson/SubTitle')}</div>
                    <div className="list">
                        {content.map(content => (
                            <Card
                                addItemHandler={() => onAddItem(content, allowMultiple)}
                                title={SystemText('Admin/Forms/FilePicker/Content/Richardson/Card/Title', content.name)}
                                label={content.name}
                                name={content.owner_Full_Name}
                                summary={content.summary}
                                date={content.created}
                                key={`${content.id}-${content.owner_Id}`}
                            >
                                <div className="blob-image-holder blob-image-holder-100">
                                    {content.image ? (
                                        <BlobImage folder="richardson-thumb" src={content.image} alt="" partnerId="1" />
                                    ) : (
                                        <img src="/dist/img/accelerate-icon.png" alt="" loading="lazy" />
                                    )}
                                </div>
                            </Card>
                        ))}
                    </div>
                    {Boolean(content?.length) && (
                        <Paging pageSize={pageSize} recordCount={recordCount} page={page} goToPage={page => setPage(page)} />
                    )}
                </>
            )}
        </div>
    );
};

export default Richardson;
